import { render, staticRenderFns } from "./createCorpSalesTestimonial.vue?vue&type=template&id=5eef18ab&"
import script from "./createCorpSalesTestimonial.vue?vue&type=script&lang=js&"
export * from "./createCorpSalesTestimonial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports